import api from "../index";
import { qs } from "../../utils/utils.js";

export const GetTransactionsApi = (userId, params) => api.get(`wallet/get-transaction?${qs(params)}`, userId);